// src/components/MainContent/MainContent.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import { useSidebar } from "../../contexts/SidebarContext";

import Users from "../../pages/Admin/Users/Users";
import TeamLigueAdmin from "../../pages/Admin/TeamLigueAdmin/TeamLigueAdmin";
import ClubsNAAdmin from "../../pages/Admin/ClubsNAAdmin/ClubsNAAdmin";
import NotificationList from "../../pages/Admin/NotificationList/NotificationList";
import VotePage from "../../pages/Admin/VotePage/VotePage";
import CalendrierAdmin from "../../pages/Admin/CalendrierAdmin/CalendrierAdmin";
import InscriptionsCN from "../../pages/Admin/InscriptionsCN/InscriptionsCN";
import Settings from "../../pages/Admin/Settings/Settings";
import ErrorPage from "../../pages/ErrorPage/ErrorPage";
import DashboardAdmin from "../../pages/Admin/DashboardAdmin/DashboardAdmin";
import ValidationBadgesUsers from "../../pages/Admin/ValidationBadgesUsers/ValidationBadgesUsers";
import LicenciesAdmin from "../../pages/Admin/LicenciesAdmin/LicenciesAdmin";
import FormationDirigeantsAdmin from "../../pages/Admin/FormationDirigeants/TrainingArticlesAdmin";
import ExpensePageAdmin from "../../pages/Admin/ExpenseClaims/ExpensePageAdmin";
import GroupsPage from "../../pages/Admin/GroupsPage/GroupsPage";
import ActeursPage from "../../pages/Admin/ActeursPage/ActeursPage";
import ConvocationsAdminPage from "../../pages/Admin/ConvocationsAdminPage/ConvocationsAdminPage";
import ConvocationByEventPage from "../../pages/Admin/ConvocationsAdminPage/ConvocationByEventPage";
import ReglementsArbitrage from "../../pages/Admin/ReglementsArbitrage/ReglementsArbitrage";
import QuizzArbitrage from "../../pages/Admin/QuizzArbitrage/QuizzArbitrage";

export default function MainContent() {
  const { isCollapsed } = useSidebar();

  return (
    <main
      className={`min-h-screen w-full transition-[margin] duration-300 ${
        isCollapsed ? "lg:ml-24" : "lg:ml-72"
      }`}
    >
      <div className="relative min-h-screen overflow-x-hidden bg-slate-100 text-slate-900 dark:bg-slate-950 dark:text-slate-100 mt-4">
        <div className="pointer-events-none absolute inset-0 opacity-60 dark:opacity-40">
          <div className="absolute -top-24 right-[-120px] h-72 w-72 rounded-full bg-indigo-300/30 blur-3xl dark:bg-indigo-500/10" />
          <div className="absolute left-[-120px] top-[20%] h-72 w-72 rounded-full bg-emerald-300/20 blur-3xl dark:bg-emerald-500/10" />
        </div>

        <div className="relative min-h-screen px-2 pb-6 sm:px-3 lg:px-4">
          <Routes>
            <Route path="dashboard" element={<DashboardAdmin />} />
            <Route path="utilisateurs" element={<Users />} />
            <Route path="badge-users" element={<ValidationBadgesUsers />} />
            <Route path="ligue-commissions" element={<TeamLigueAdmin />} />
            <Route
              path="formation-dirigeants"
              element={<FormationDirigeantsAdmin />}
            />
            <Route path="notifications" element={<NotificationList />} />
            <Route path="clubs-admin" element={<ClubsNAAdmin />} />
            <Route path="groupes" element={<GroupsPage />} />
            <Route path="acteurs" element={<ActeursPage />} />
            <Route path="calendrier" element={<CalendrierAdmin />} />
            <Route path="convocations" element={<ConvocationsAdminPage />} />
            <Route
              path="convocations-admin/:eventId"
              element={<ConvocationByEventPage />}
            />
            <Route path="reglements-arbitrage" element={<ReglementsArbitrage />} />
            <Route path="quizz-arbitrage" element={<QuizzArbitrage />} />
            <Route path="inscriptions-cn" element={<InscriptionsCN />} />
            <Route path="licencies-inscrits" element={<LicenciesAdmin />} />
            <Route path="expense-claims" element={<ExpensePageAdmin />} />
            <Route path="votes-admin" element={<VotePage />} />
            <Route path="parametres" element={<Settings />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </div>
      </div>
    </main>
  );
}